import { bindActionCreators } from 'redux'
import {
  fetchInitialDsrData,
  getDsrFeedContent,
  resetDsrFeedContent,
  resetDsrPages,
  resetDsrSelectedDisplaySubpage,
  resetDsrTitle,
  setShowDsrModal,
  setUserActionRequired,
  updateDsrReset,
  updateDsr
} from '../actions/dsr-actions'
import { connect } from 'react-redux'
import { DsrEditDraftPage } from './DsrEditDraftPage'
import { useLocation, withRouter } from 'react-router-dom'
import { duplicateDsrPage } from '../actions/duplicate-dsr-page-actions'
import { unlockRoom } from '../../global/actions/global-actions'

const DsrEditDraftPageContainer = (props) => {
  const location = useLocation();
  const isLiveEdit = (location.pathname.startsWith("/edit")) ? true : false;

  return <DsrEditDraftPage {...props} isLiveEdit={isLiveEdit} />
}

const mapStateToProps = (state) => ({
  dsrFeedContent: state.dsrFeedContent.results,
  currentDsrId: state.dsrFeedContent.id,
  dsrPagesRedux: state.setDsrPages.pages,
  dsrInvalidRequestRedux: state.dsrInvalidRequest.request,
  dsrTeamMembersRedux: state.dsrTeamMembers.members,
  showDsrModalRedux: state.dsrModal.showDsrModal,
  userActionRequiredRedux: state.dsrPopup.UserActionRequired,
  dsrTitle: state.dsrTitle.title,
  showDsrModalLoaderRedux: state.showDsrModalLoader.show,
  selectedDisplaySubpage: state.changeDsrPage.selectedDisplaySubpage,
  isMobileView: state.mobileViewMode.isMobileView,
  isLockedRoom :state.lockedRoomCheck.isLockedRoom,
  lockedRoomMetadata: state.lockedRoomMetadata.results,
  hideOptionForInvalidLink: state.hideOptionForInvalidLink.isHideOptionsForInvalidLink
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getDsrFeedContent,
      setShowDsrModal,
      setUserActionRequired,
      fetchInitialDsrData,
      resetDsrFeedContent,
      resetDsrTitle,
      resetDsrSelectedDisplaySubpage,
      resetDsrPages,
      duplicateDsrPage,
      updateDsr,
      updateDsrReset,
      unlockRoom
    },
    dispatch,
  )

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(DsrEditDraftPageContainer),
)
